module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/for-sale-houses-line-a580e11050956acce7d6d58e4547394e.svg";